import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Card, CardFooter, type TCardProps } from '@/src/elements/card'
import { Image, type TImageProps } from '@/src/elements/image'
import { Typography } from '@/src/elements/text/Typography'

export type TImageCard = {
  className?: string
  textContainerClassName?: string
  typographyClassName?: string
  imageSrc: string | number | string[]
  content: ReactNode
} & TCardProps &
  Pick<TImageProps, 'contentFit' | 'contentPosition'>

export const ImageCard = ({
  content,
  contentFit = 'cover',
  contentPosition,
  imageSrc,
  className,
  textContainerClassName,
  typographyClassName,
  ...otherProps
}: TImageCard): ReactNode => (
  <Card {...otherProps} className={clsx('h-full', className)}>
    <Image
      source={imageSrc}
      className="h-full w-full"
      contentFit={contentFit}
      contentPosition={contentPosition}
      radius="lg"
      transition={null}
    />
    <CardFooter className={clsx('absolute bottom-0 text-default-label-solid', textContainerClassName)}>
      <Typography
        bold
        className={clsx(
          'stroke line-clamp-2 stroke-default-text-contrast-default text-default-label-solid',
          typographyClassName,
        )}
      >
        {content}
      </Typography>
    </CardFooter>
  </Card>
)
